
import { ContentItem, Elements } from '@kentico/kontent-delivery';

/**
 * Generated by '@kentico/kontent-model-generator@3.2.0'
 
 */
export class Home extends ContentItem {
        constructor() {
        super({
            propertyResolver: ((elementName) => {
                if (elementName === 'hero_banner') {
                    return 'heroBanner';
                }
                return elementName;
            })
        });
    }
}
